<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->
<template>
  <!-- 用户管理 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="36">
          <a-col :md="4"
                 :sm="24"
                 v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择"
                        default-value
                        v-model="query.tenantId"
                        @change="tenantChange"
                        allow-clear>
                <a-select-option value>全部</a-select-option>
                <a-select-option v-for="item in tenantList"
                                 :key="item.tenantId"
                                 :value="item.tenantId">{{
                    item.tenantName
                  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4"
                 :sm="24">
            <a-form-item label="部门">
              <a-tree-select :tree-data="deptTreeData"
                             v-model="query.deptId"
                             style="width: 100%"
                             :replace-fields="{ title: 'deptName', key: 'id', value: 'id' }"
                             :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                             placeholder="请选择部门"
                             allow-clear
                             tree-default-expand-all></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="4"
                 :sm="24">
            <a-form-item label="用户名">
              <a-input v-model="query.username"
                       placeholder="请输入用户名或姓名手机"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4"
                 :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择"
                        default-value
                        v-model="query.status">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">锁定</a-select-option>
                <!-- <a-select-option value="3">禁用</a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="addOrUpdateHandle()"
                        v-action:add>新增</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()"
                        v-action:del>删除</a-button>
              <a-tooltip placement="topLeft"
                         title="水司默认用户不能删除">
                <span style="margin-left: 10px">
                  <a-icon type="question-circle"
                          style="color: red" />
                </span>
              </a-tooltip>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             size="middle"
             :row-selection="{
        selectedRowKeys: this.selectedRows,
        onChange: onSelectChange,
        getCheckboxProps: onGetCheckboxPros,
      }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             @change="pageChange">
      <!-- <a-tag color="blue" slot="status" slot-scope="text">{{ text | statusFilter }}</a-tag> -->
      <span slot="status"
            slot-scope="text">
        <a-tag color="rgb(50, 205, 50)"
               v-if="text == 1">正常</a-tag>
        <a-tag color="#ff6602db"
               v-if="text == 2">锁定</a-tag>
        <!-- <a-tag color="rgb(255, 99, 71)" v-if="text == 3">禁用</a-tag> -->
      </span>
      <span slot="createTime"
            slot-scope="text">{{ text | moment }}</span>
      <span slot="action"
            slot-scope="text, record">
        <span v-if="record.tenantId === currentTenantId || record.tenantDefaultUser">
          <a @click="addOrUpdateHandle(record.id, record)"
             v-action:edit>编辑</a>
          <a-divider type="vertical" />
        </span>
        <a @click="resetUserPassword(record.id)"
           v-action:repassword>重置密码</a>
      </span>
    </a-table>
    <a-modal title="操作"
             style="top: 20px"
             :width="800"
             v-model="addOrUpdateVisible"
             @ok="handleOk"
             @cancel="handleCancel">
      <a-form class="user-form"
              :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="登录账号"
                     hasFeedback>
          <a-input :disabled="this.isUpdate"
                   placeholder="登录账号"
                   v-decorator="[
              'username',
              {
                rules: [
                  { required: true, message: '请输入登录账号' },
                  { validator: checkData, trigger: 'blur' },
                ],
              },
            ]" />
        </a-form-item>
        <a-form-item v-if="!this.isUpdate"
                     :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="登录密码"
                     hasFeedback>
          <a-input-password placeholder="登录密码"
                            v-decorator="['password', { rules: [{ required: true, message: '请输入登录密码' },{ validator: validatePassword, trigger: 'blur'}] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="真实名字"
                     hasFeedback>
          <a-input placeholder="真实名字"
                   v-decorator="['realName', { rules: [{ required: true, message: '请输入真实名字' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="昵称"
                     hasFeedback>
          <a-input placeholder="昵称"
                   v-decorator="['nickName']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="状态">
          <a-select placeholder="请选择"
                    v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }] }]">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">锁定</a-select-option>
            <!-- <a-select-option :value="3">禁用</a-select-option> -->
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="角色">
          <a-select mode="multiple"
                    style="width: 100%"
                    placeholder="请选择角色"
                    :disabled="this.tenantDefaultUser == true && this.systemAdmin !== true"
                    v-decorator="[
              'roleIdList',
              { rules: [{ required: true, message: '请选择角色', type: 'array' }], initialValue: undefined },
            ]">
            <a-select-option v-for="item in roleList"
                             :key="item.id"
                             :value="item.id"
                             :label="item.roleName">{{
                item.roleName
              }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="手机"
                     hasFeedback>
          <a-input placeholder="请输入手机"
                   v-decorator="['phone', { rules: [{ pattern: '^1[0-9]{10}$', message: '请输入负责人手机' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="邮箱"
                     hasFeedback>
          <a-input v-decorator="[
              'email',
              {
                rules: [
                  {
                    pattern: '^[A-Za-z0-9-_\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$',
                    message: '请输入负责人邮箱',
                  },
                ],
              },
            ]"
                   placeholder="请输入邮箱" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="部门">
          <a-tree-select :tree-data="deptTreeData"
                         v-decorator="['deptId']"
                         style="width: 100%"
                         :replace-fields="{ title: 'deptName', key: 'id', value: 'id' }"
                         :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                         placeholder="请选择部门"
                         allow-clear
                         tree-default-expand-all></a-tree-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--  重置密码操作  -->
    <a-modal title="重置密码"
             style="top: 20px"
             :width="800"
             v-model="resetPasswordVisible"
             @ok="handleResetPassword"
             @cancel="handleRestPasswordCancel">
      <a-form class="tenant-form"
              :form="resetPasswordForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="登录账号"
                     hasFeedback>
          <a-input hidden
                   v-decorator="['id']" />
          <a-input disabled
                   placeholder="登录账号"
                   v-decorator="['username']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="真实姓名"
                     hasFeedback>
          <a-input disabled
                   placeholder="真实姓名"
                   v-decorator="['realName']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="登录密码"
                     hasFeedback>
          <a-input-password placeholder="登录密码"
                            v-decorator="['password', { rules: [{ required: true, message: '请输入登录密码' },{ validator: validatePassword, trigger: 'blur'}] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const STATUS = {
  1: '正常',
  2: '锁定'
}

const columns = [
  {
    title: '用户名',
    dataIndex: 'username'
  },
  {
    title: '姓名',
    dataIndex: 'realName'
  },
  {
    title: '手机',
    dataIndex: 'phone',
    width: 120
  },
  {
    title: '邮箱',
    dataIndex: 'email'
  },
  {
    title: '昵称',
    dataIndex: 'nickName',
    width: 120
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '部门',
    dataIndex: 'deptName'
  },
  {
    title: '水司名称',
    dataIndex: 'tenantName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'UserList',
  data () {
    return {
      queryUrl: 'manager/users/page',
      addOrUpdateUrl: 'manager/users',
      queryOneUrl: 'manager/users',
      deleteUrl: 'manager/users',
      tenantList: [], // 水司数据选择
      deptTreeData: [], // 部门数据选择
      roleList: [], // 角色选择
      tenantDefaultUser: false,
      systemAdmin: false,
      addshwo: false,
      userId: '',
      query: {
        username: '',
        status: '',
        tenantId: '',
        deptId: '', // 部门ID
        realName: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      resetPasswordForm: this.$form.createForm(this, { name: 'restPassword' }),
      resetPasswordVisible: false,
      currentTenantId: this.$store.state.user.info.tenantId
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.init()
    this.currentUser()
  },
  methods: {
    currentUser () {
      this.$store.getters.userInfo.nickName
      this.systemAdmin = this.$store.getters.userInfo.systemAdmin
      // this.engineeringProjectEstab.establishmentUserId = this.$store.getters.userInfo.nickName
    },
    // 水司默认用户不可以进行删除操作
    onGetCheckboxPros (record) {
      return {
        props: {
          disabled: record.tenantDefaultUser
        }
      }
    },
    validPassword (value) {
      const num = /^.*[0-9]+.*/
      const low = /^.*[a-z]+.*/
      const up = /^.*[A-Z]+.*/
      const spe = /^.*[^a-zA-Z0-9]+.*/
      const passLength = value.length > 5 && value.length < 21
      return num.test(value) && low.test(value) && up.test(value) && spe.test(value) && passLength
    },
    validatePassword (rule, value, callback) {
      const that = this
      console.log('===validatePassword===')
      if (that.validPassword(value)) callback()
      else callback(new Error('密码6-20位，必须包含大写字母，小写字母，数字及特殊字符'))
    },
    // 正则验证
    checkData (rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('登录账号只能输入英文或数字、特殊符号!'))
        } else {
          callback()
        }
      }
      callback()
    },
    init () {
      this.getDeptTreeInfo()
      this.getRoleList()
      this.getAllTenant()
    },
    resetUserPassword (id) {
      this.resetPasswordVisible = true
      this.$http
        .get(`${this.queryOneUrl}/${id}`)
        .then(({ data }) => {
          this.resetPasswordForm.setFieldsValue(data)
        })
        .catch(() => { })
    },
    handleResetPassword (e) {
      e.preventDefault()
      this.resetPasswordForm.validateFields((err, values) => {
        console.log(values)
        if (!err) {
          this.$http
            .put('/manager/users/reset-password', { userId: values.id, password: values.password })
            .then((res) => {
              if (res.code === 0) {
                this.resetPasswordVisible = false
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    handleRestPasswordCancel () {
      this.resetPasswordVisible = false
    },
    getRoleList () {
      this.$http
        .get('/manager/roles', {
          params: {
            userId: this.userId
          }
        })
        .then(({ data }) => {

          this.roleList = data
        })
        .catch(({ e }) => {
          console.log(e)
        })
    },
    getDeptTreeInfo () {
      this.$http
        .get('/manager/dept/tree')
        .then((res) => {
          this.deptTreeData = res.data
        })
        .catch(() => { })
    },
    tenantChange (tenantId) {
      this.query.deptId = ''
      this.$http
        .get(`/manager/dept/tenant/tree?tenantId=${tenantId}`)
        .then((res) => {
          this.deptTreeData = res.data
        })
        .catch(() => { })
    },
    addOrUpdateHandle (id, record) {
      if (record !== undefined) {
        this.addshwo = true
        this.tenantDefaultUser = record.tenantDefaultUser
      } else {
        this.addshwo = false
      }
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.userId = data.id
            console.log(data, 'id')
            if (data.tenantId !== this.$store.state.user.info.tenantId) {
              this.tenantChange(data.tenantId)
            }
            data.roleIdList === null ? (data.roleIdList = []) : ''
            this.addOrUpdateForm.setFieldsValue(data)
            this.getRoleList()
          })
          .catch(() => { })
      }
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, { id: this.currentId, ...values })
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
      this.init()
    },
    handleCancel () {
      this.init()
      this.tenantDefaultUser = false
      this.addOrUpdateForm.resetFields()
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.user-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
